import {openTalk} from "@COMPONENTS/common/commonUtil";
import SSOLink from "@COMPONENTS/common/ssoLink";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import * as style from "@FRAMEWORK/ui/desktop/footer";
import useGlobalMenu, {GlobalMenu} from "@QUERIES/bff/global/useGlobalMenu";
import {useRouter} from "next/router";
import {useCallback, useEffect, useState} from "react";

const Footer = () => {
	const router = useRouter();
	const [topShow, setTopShow] = useState(false);
	const [lastScrollTop, setLastScrollTop] = useState(0);

	const handleScroll = () => {
		const currentScrollTop = window.scrollY || document.documentElement.scrollTop;

		if (currentScrollTop > lastScrollTop) {
			setTopShow(false);
		} else {
			setTopShow(true);
		}
		setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
	};

	const onClickAward = (value: string) => {
		window.open(
			`https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html${value ? `#award=${value}` : ""}`,
			"popupWindow",
			"width=600,height=720,left=200,top=200",
		);
	};

	const top = useCallback(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [lastScrollTop, router]);

	/** 해피톡 */
	const [talk, setTalk] = useState<GlobalMenu | null>(null);
	const globalMenuFetch = useGlobalMenu();
	const globalMenu = globalMenuFetch.data?.body;
	useEffect(() => {
		if (!router.query.dspSid || !router.pathname.includes("/product/localList") || !globalMenu) return;
		const target = globalMenu.menuLv3List.find(v => v.dspSid === router.query.dspSid && v.talkYn === "Y") || null;
		if (target) setTalk(target);
	}, [router.pathname, router.query.dspSid, globalMenu]);

	return (
		<>
			<style.FooterWrap className="footer">
				<style.Fnb>
					<nav>
						<div>
							<ul>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/main.yb`}>고객센터</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/noticeList.yb`}>공지사항</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/faqList.yb`}>자주하는질문</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/qnaGuide.yb`}>1:1문의</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/estimateWrite.yb`}>견적문의</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/eplg/episodeList.yb`}>여행후기</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/praiseList.yb`}>칭찬합시다</SSOLink>
								</li>
								<li>
									<SSOLink
										href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/freeInstallmentPopup.yb`}
										target="_blank"
										rel="noreferrer"
									>
										무이자할부
									</SSOLink>
								</li>
								<li>
									<SSOLink
										href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=`}
										target="_self"
									>
										현금영수증
									</SSOLink>
								</li>
							</ul>
						</div>
					</nav>
				</style.Fnb>
				<style.CsWrap>
					<div>
						<article>
							<p>노랑풍선 고객센터</p>
							<dl>
								<dt>상담시간</dt>
								<dd>평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)</dd>
							</dl>
							<ul>
								<li>
									<p>
										해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:
										<br />
										평일 오후 5시까지
									</p>
								</li>
								<li>
									<p>호텔 취소/변경/환불: 평일 오후 4시까지</p>
								</li>
							</ul>
						</article>
						<article>
							<ul>
								<li>
									<p>패키지여행 상담</p>
									<p>
										<em>1544-2288</em>
									</p>
									<button
										onClick={() => {
											window.open(`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/arsGuide.yb`);
										}}
									>
										지역별 직통 상담번호 안내
									</button>
								</li>
								<li>
									<p>자유여행 상담</p>
									<p>
										<em>1644-3399</em>
									</p>
								</li>
								<li>
									<p>부산/지방출발 상담</p>
									<p>
										<em>051-713-0710</em>
									</p>
								</li>
							</ul>
						</article>
					</div>
				</style.CsWrap>
				<style.LinkWrap>
					<nav>
						<div>
							<style.Policies>
								<li>
									<SSOLink href={publicRuntimeConfig.ENV_COMPANY_URL} target="_blank" rel="noreferrer">
										회사소개
									</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/privacy.yb`}>
										<em>개인정보처리방침</em>
									</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/internetAgree.yb`}>이용약관</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/travelAgree.yb`}>여행약관</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/travelerInsuInfo.yb`}>
										여행자보험
									</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_COMPANY_URL}/agent/about`} target="_blank" rel="noreferrer">
										대리점안내
									</SSOLink>
								</li>
								<li>
									<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/directionGuide.yb`}>오시는 길</SSOLink>
								</li>
							</style.Policies>
							<style.Sns>
								<style.SnsItem $sns="facebook">
									<SSOLink href="https://www.facebook.com/yellowballoonofficial/" target="_blank" rel="noreferrer">
										<span>노랑풍선 페이스북 바로가기</span>
									</SSOLink>
								</style.SnsItem>
								<style.SnsItem $sns="instagram">
									<SSOLink href="https://www.instagram.com/yellowballoon_official/" target="_blank" rel="noreferrer">
										<span>노랑풍선 인스타 바로가기</span>
									</SSOLink>
								</style.SnsItem>
								<style.SnsItem $sns="youtube">
									<SSOLink href="https://www.youtube.com/user/ybtour2013" target="_blank" rel="noreferrer">
										<span>노랑풍선 유튜브 바로가기</span>
									</SSOLink>
								</style.SnsItem>
								<style.SnsItem $sns="kakao">
									<SSOLink href="https://pf.kakao.com/_hhAxbd" target="_blank" rel="noreferrer">
										<span>노랑풍선 플러스친구 바로가기</span>
									</SSOLink>
								</style.SnsItem>
								<style.SnsItem $sns="blog">
									<SSOLink href="https://blog.naver.com/yb_tour" target="_blank" rel="noreferrer">
										<span>노랑풍선 네이버블로그 바로가기</span>
									</SSOLink>
								</style.SnsItem>
							</style.Sns>
						</div>
					</nav>
				</style.LinkWrap>
				<style.CompanyInfo>
					<style.Corporation>
						<article>
							<h5>
								(주)노랑풍선
								<img src="https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png" alt="코스닥상장법인" />
							</h5>
							<address>
								대표이사 김진국<i></i>서울특별시 중구 수표로31, 노랑풍선빌딩
								<br />
								사업자등록번호 104-81-64440 <i></i>관광사업자등록증번호 제2006-000003호<i></i>통신판매업신고번호
								제2008-서울중구-0278
								<SSOLink href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440" target="_blank" rel="noreferrer">
									사업자 정보확인
								</SSOLink>
							</address>
							<address>
								[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)
								<br />
								사업자등록번호 870-85-01900
							</address>
							<span>
								영업배상책임보험가입 총 20억원 · 한국관광협회중앙회 여행공제회 공제영업보증가입 15억 1천만원 ·
								공제기획여행보증가입 7억원
							</span>
							<style.LogoList>
								<li>
									<SSOLink href="http://tourinfo.or.kr/standard/partners.asp" target="_blank" rel="noreferrer">
										<span>국외여행상품 정보제공 표준안 참여 여행사</span>
									</SSOLink>
								</li>
								<li>
									<SSOLink
										href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=`}
										target="_self"
										rel="noreferrer"
									>
										<span>현금영수증 의무발행 가맹점</span>
									</SSOLink>
								</li>
							</style.LogoList>
						</article>
						<article>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/cs/main.yb`}>고객센터</SSOLink>
							<span>
								<dl>
									<dt>패키지여행 상담</dt>
									<dd>1544-2288</dd>
								</dl>
								<dl>
									<dt>자유여행 상담</dt>
									<dd>1644-3399</dd>
								</dl>
								<dl>
									<dt>부산/지방출발 상담</dt>
									<dd>051-713-0710</dd>
								</dl>
							</span>
							<ul>
								<li>
									<em>대표메일</em>
									<SSOLink href="mailto:master@ybtour.com">master@ybtour.com</SSOLink>
								</li>
								<li>
									<em>판매제휴</em>
									<SSOLink href="mailto:salespartner@ybtour.com">salespartner@ybtour.com</SSOLink>
								</li>
								<li>
									<em>마케팅제휴</em>
									<SSOLink href="mailto:marketing@ybtour.com">marketing@ybtour.com</SSOLink>
								</li>
								<li>
									<em>대리점문의</em>
									<SSOLink href="mailto:sales.agent@ybtour.co.kr">sales.agent@ybtour.co.kr</SSOLink>
								</li>
							</ul>
						</article>
					</style.Corporation>
				</style.CompanyInfo>
				<section>
					<div>
						<style.AwardList>
							<style.AwardListItem $award="ccm">
								<button onClick={() => onClickAward("award1")}>
									<span>소비자중심경영 명예의 전당 표창장</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="ftc">
								<button onClick={() => onClickAward("award2")}>
									<span>소비자중심경영 국무총리 표창</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="ccm2023">
								<button onClick={() => onClickAward("award3")}>
									<span>소비자중심경영 공정거래위원장 표창</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="knqa">
								<button onClick={() => onClickAward("award4")}>
									<span>제45회 국가품질경영대회서비스품질우수상</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="scsi">
								<button onClick={() => onClickAward("award5")}>
									<span>SCSI 대한민국 소셜미디어대상 1위</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="icsi">
								<button onClick={() => onClickAward("award5")}>
									<span>ICSI 대한민국 인터넷소통대상 기업부문 대상 1위</span>
								</button>
							</style.AwardListItem>
							<style.AwardListItem $award="isms">
								<button onClick={() => onClickAward("award6")}>
									<span>정보보호 관리체계 인증</span>
								</button>
							</style.AwardListItem>
						</style.AwardList>
						<style.CopyrightWrap>
							<ul>
								<li>
									노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다.
									따라서 해당 상품의 상품·거래정보 및 거래 등에 대하여 책임을 지지 않습니다.
								</li>
								<li>
									항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된
									가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다.
								</li>
								<li>
									노랑풍선의 &apos;예금주&apos; 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에
									관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에
									노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다.
								</li>
								<li>
									고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.
									<SSOLink href="https://pkg.ybtour.co.kr/cs/travelSafetyGuide.yb" target="_blank" rel="noreferrer">
										자세히보기
									</SSOLink>
								</li>
							</ul>
						</style.CopyrightWrap>
						<p>© Yellow Balloon tour. All Rights Reserved.</p>
					</div>
				</section>
			</style.FooterWrap>
			<style.FloatingBlock>
				{/* 해피톡 */}
				{talk && (
					<style.TalkWrap $show={topShow}>
						<style.TalkBtn onClick={() => openTalk(talk.talkUrl)}>
							<span>해피톡 상담</span>
						</style.TalkBtn>
						<div>
							<span>{talk.talkMsg}</span>
						</div>
					</style.TalkWrap>
				)}
				<style.TopButton $show={topShow} onClick={top}>
					<span>최상단 이동</span>
				</style.TopButton>
			</style.FloatingBlock>
		</>
	);
};
export default Footer;
